module.exports = __webpack_public_path__ + "img/main-04-03.fc001ec3.png";